<template>
    <!-- 상품 카테고리 -->
    <ul class="mobile-category__level mobile-category__level--1">
        <li>
            <router-link tag="a" to="/shop/categories" class="mobile-category__level-link" @click="close">전체보기</router-link>
        </li>
        <li v-for="item in items" :key="item._id">
            <!-- 선택된 카테고리 -->
            <router-link tag="a" data-toggle="true" :to="`/shop/categories/${item._id}`" class="mobile-category__level-link">
                {{ item.name }}
            </router-link>
        </li>
    </ul>
</template>

<script>
import { mapActions, mapState } from "vuex";
import detect from "@/plugins/detect";

export default {
    props: {
        store: { type: Object, default: null },
        _category: String,
        value: Boolean,
    },
    data(){
        return { detect }; 
    },
    computed: {
        ...mapState({ items: (state) => state?.shop?.categories }),
    },
    created() {
        this.init();
    },
    methods: {
        ...mapActions("shop", ["getCategories"]),
        async init() {
            try {
                await this.getCategories();
            } catch (error) {
                console.error(error);
            }
        },
        close() {
            if(this.detect == "mobile"){
                const HEADER = document.querySelector(".header");
                HEADER.setAttribute("data-sidebar", "closed");
            }
        },
    },
    watch: {
        "$route.path"() {
            this.close();
        },
    },
};
</script>
